import { fetcher } from "@/services/api/fetcher";
import { useQuery } from "@tanstack/react-query";
import {
  AssetsDetailResponse,
  AssetsMonitoringDetailResponse,
  AssetsMonitoringResponse,
  AssetsResponse,
} from "./interface";

export const useGetAssets = (params?: string) =>
  useQuery<ApiResponse<DataPaginate<AssetsResponse>>>({
    queryKey: ["useGetAssets", params],
    queryFn: () => fetcher(`alsintan/asset/group/alsintan?${params}`),
  });

export const useGetAssetsDetail = (id: number, type: string) =>
  useQuery<ApiResponse<DataPaginate<AssetsDetailResponse>>>({
    queryKey: ["useGetAssets", id, type],
    queryFn: () => fetcher(`alsintan/asset/group/alsintan-jenis/${id}/${type}`),
  });

export const useGetAssetsById = (id?: number) =>
  useQuery<ApiResponse<DataObject<AssetsDetailResponse>>>({
    queryKey: ["useGetAssetsById", id],
    queryFn: () => fetcher(`alsintan/asset/${id}`),
    enabled: !!id,
  });

// monitoring

export const useGetAssetsMonitoring = (id: number, params?: string) =>
  useQuery<ApiResponse<DataPaginate<AssetsMonitoringResponse>>>({
    queryKey: ["useGetAssetsMonitoring", id, params],
    queryFn: () => fetcher(`alsintan/asset-monitoring/asset/${id}?${params}`),
    enabled: !!id,
  });

export const useGetAssetsMonitoringById = (id: number) =>
  useQuery<ApiResponse<DataObject<AssetsMonitoringDetailResponse>>>({
    queryKey: ["useGetAssetsMonitoringById", id],
    queryFn: () => fetcher(`alsintan/asset-monitoring/${id}`),
    enabled: !!id,
  });
